import { T } from '../customer/customers.theme';

/**
 * Every user-facing string in the vendors book.
 *
 * The phone calls a vendor a SHIRKAD — "+ Ku Dar Shirkad", "Search Shirkad",
 * "Ma jiraan Shirkado" — so this screen does too. That is the rule for this
 * app: English unless the phone is Somali there, and then the phone's word
 * exactly.
 *
 * Bixin and Deen Cusub carry over from the customers book unchanged, because
 * they are the same two motions: money out, and a new debt. Only who owes whom
 * has flipped.
 */
export const COPY = {
  title: 'Vendors',
  add: 'Ku Dar Shirkad',
  addLong: '+ Ku Dar Shirkad',
  search: 'Search Shirkad',
  none: 'Ma jiraan Shirkado',
  noneFound: 'No vendors found',
  loading: 'Loading…',

  count: (n) => `${n} ${n === 1 ? 'vendor' : 'vendors'}`,

  // The shop owes THEM, which is the opposite of the customers book.
  totalOwing: 'Total owing',
  owing: 'Owing',
  inCredit: 'In credit',
  settled: 'Settled',

  payment: 'Bixin',
  charge: 'Deen Cusub',

  // Ledger
  ledgerDate: 'Date',
  ledgerDescription: 'Description',
  ledgerDebit: 'Deen',
  ledgerCredit: 'Bixin',
  ledgerBalance: 'Balance',
  emptyLedger: 'Wax dhaqdhaqaaq ah majiro',
  emptyLedgerBody: 'An expense filed on invoice appears here by itself.',
  pickTitle: 'No vendor selected',
  pickBody: 'Pick a supplier from the list to see what the shop owes them.',

  edit: 'Edit',
  agent: 'Agent',
  phone: 'Phone',
  limit: 'Limit',

  // Form
  formAdd: 'Ku Dar Shirkad',
  formEdit: 'Edit Shirkad',
  name: 'Name',
  nameRequired: 'Enter a name',
  saveFailed: 'Could not save. Try again.',
  save: 'Save',

  // Transaction dialog
  paymentTitle: (name) => `Bixin · ${name}`,
  chargeTitle: (name) => `Deen Cusub · ${name}`,
  amount: 'Amount',
  description: 'Description',
  date: 'Date',
  amountRequired: 'Enter an amount',
  amountInvalid: 'Not a valid amount',
  record: 'Save',
  cancel: 'Cancel',
  currentlyOwing: 'The shop currently owes',
  afterThis: 'After this',

  // Delete
  deleteTitle: 'Delete entry',
  deleteBody: 'Are you sure you want to delete this entry?',
  deleteNote: 'The balance it moved is put back.',
  delete: 'Delete',
};

/**
 * The colour of a vendor balance.
 *
 * Deliberately NOT the customers book's `balanceColor`, which reads backwards
 * for suppliers: there, brand orange means "they owe us" and red means the
 * shop is in debt. Here a positive balance IS the shop in debt, so:
 *
 *   > 0   the shop owes them      — brand, the figure that needs attention
 *   = 0   square                  — settled green
 *   < 0   they owe the shop back  — plain ink, an oddity rather than an alarm
 */
export function vendorBalanceColor(balance) {
  const value = Number(balance || 0);
  if (value > 0) return T.brand;
  if (value === 0) return T.paid;
  return T.ink;
}

/** The word for where a balance stands, used beside the figure. */
export function vendorBalanceLabel(balance) {
  const value = Number(balance || 0);
  if (value > 0) return COPY.owing;
  if (value === 0) return COPY.settled;
  return COPY.inCredit;
}
